import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy } from "react-table";
import "./App.css";

const App = () => {
  const [menuItems, setMenuItems] = useState( [
    {
      "id": 0,
      "name": "Uthappizza",
      "image": "https://i.imgur.com/tDnjTXf.jpg",
      "category": "mains",
      "label": "Hot",
      "price": "4.99",
      "description": "A unique combination of Indian Uthappam (pancake) and Italian pizza"
    },
    {
      "id": 1,
      "name": "Zucchipakoda",
      "image": "https://i.imgur.com/xkUElXq.jpg",
      "category": "appetizer",
      "label": "",
      "price": "1.99",
      "description": "Deep fried Zucchini coated with mildly spiced Chickpea flour batter accompanied with a sweet-tangy tamarind sauce"
    },
    {
      "id": 2,
      "name": "Vadonut",
      "image": "https://i.imgur.com/anUAlqF.jpg",
      "category": "appetizer",
      "label": "New",
      "price": "1.99",
      "description": "A quintessential ConFusion experience, is it a vada or is it a donut?"
    },
    {
      "id": 3,
      "name": "ElaiCheese Cake",
      "image": "https://i.imgur.com/c5hBTEW.jpg",
      "category": "dessert",
      "label": "",
      "price": "2.99",
      "description": "A delectable, semi-sweet New York Style Cheese Cake, with Graham cracker crust and spiced with Indian cardamoms"
    },
    {
      "id": 4,
      "name": "Guntur chillies",
      "image": "https://i.imgur.com/Vc9JIXP.jpg",
      "category": "appetizer",
      "label": "Spicy",
      "price": "0.99",
      "description": "Assorted chillies from Guntur"
    },
    {
      "id": 5,
      "name": "Buffalo Paneer",
      "image": "https://i.imgur.com/pH2tkgk.jpg",
      "category": "appetizer",
      "label": "",
      "price": "5.99",
      "description": "A special type of Paneer made from Buffalo milk"
    },
    {
      "id": 6,
      "name": "Cherry Tomatoes",
      "image": "https://i.imgur.com/fRy8hjE.jpg",
      "category": "clone",
      "label": "clone",
      "price": "9.99",
      "description": "clone of cherry and tomato"
    },
    {
      "id": 7,
      "name": "Goat Milk",
      "image": "https://i.imgur.com/zFGPhrI.jpg",
      "category": "weird",
      "label": "weird",
      "price": "1.99",
      "description": "Medicinal Goat Milk"
    },
    {
      "id": 8,
      "name": "Rose breasted Grosbeak chicken",
      "image": "https://i.imgur.com/RYsqgoo.jpg",
      "category": "appetizer",
      "label": "New",
      "price": "7.99",
      "description": "Roasted rare bird"
    },
    {
      "id": 9,
      "name": "Toenail Zingy",
      "image": "https://i.imgur.com/IpG3YOT.jpg",
      "category": "appetizer",
      "label": "weird",
      "price": "0.99",
      "description": "Cooked Toenails of various animals"
    }
  ] );
  const [editingItemId, setEditingItemId] = useState( null );

  const setItemsToStorage = () => {
    const menuItemsJson = JSON.stringify( menuItems );
    localStorage.setItem( "menuItems", menuItemsJson );
    setMenuItems( menuItems );
  };

  const getItemsFromStorage = () => {
    const menuItemsJson = localStorage.getItem( "menuItems" );
    if ( menuItemsJson ) {
      const menuItems = JSON.parse( menuItemsJson );
      setMenuItems( menuItems );
    }
  };
  useEffect( getItemsFromStorage, [editingItemId] );

  const columns = useMemo(
    () => {
      const handlePriceChange = ( id, price ) => {
        // Check if the price parameter is a number.
        const newPrice = Number( price );
        // If the price parameter is not a number, show an alert and return.
        if ( !newPrice ) {
          // `alert` is a built-in JavaScript function that displays an alert box.
          alert( "Price must be a number" );
          return;
        }
        // This function gets the price of a menu item by its id.
        const getPriceById = ( id ) => {
          const response = menuItems.find( ( item ) => item.id === id );
          return response.price;
        };
        // Check if the price is the same as before.
        const oldPrice = getPriceById( id );
        if ( price === oldPrice ) {
          alert( "Price is the same as before." );
          return;
        }
        const updatedMenuItems = menuItems.map( ( item ) => {
          if ( item.id === editingItemId ) {
            item.price = newPrice;
          }
          return item;
        } );
        setMenuItems( updatedMenuItems );
        setItemsToStorage();
        alert( `Price updated for item with ID => ${ id }` );
        setEditingItemId( null );
      };
      const PriceCell = ( { row, value } ) => {
        const isEditing = row.original.id === editingItemId;
        const [inputValue, setInputValue] = useState( value );
        const handleChange = ( e ) => {
          setInputValue( e.target.value );
        };
        const handleSave = () => {
          handlePriceChange( row.original.id, inputValue );
        };
        const handleEdit = () => {
          setEditingItemId( row.original.id );
        };
        return (
          <div className="price-cell">
            { isEditing ? (
              <input
                className="input-price"
                type="text"
                value={ inputValue }
                onChange={ handleChange }
              />
            ) : (
              <div className="price-value">{ value }</div>
            ) }
            { isEditing ? (
              <button
                className="save-button"
                onClick={ handleSave }
              >
                Save
              </button>
            ) : (
              <button
                className="edit-button"
                onClick={ handleEdit }
              >
                Edit
              </button>
            ) }
          </div>
        );
      };

      return [
        {
          Header: "ID",
          accessor: "id",
        },
        {
          Header: "Name",
          accessor: "name",
        },
        {
          Header: "Image",
          accessor: "image",
          Cell: ( { value } ) => (
            <img src={ value } alt="Item" style={ { width: "50px" } } />
          ),
        },
        {
          Header: "Category",
          accessor: "category",
          Aggregated: () => "All Categories",
        },
        {
          Header: "Label",
          accessor: "label",
        },
        {
          Header: "Price",
          accessor: "price",
          Cell: PriceCell,
        },
        {
          Header: "Description",
          accessor: "description",
        },
      ];
    },
    [editingItemId] // Add editingItemId as a dependency for useMemo
  );

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable(
      {
        columns,
        data: menuItems,
      },
      useSortBy
    );

  return (
    <div className="container">
      <p className="tableTitle">Menu Items</p>
      <table { ...getTableProps() } className="table">
        <thead>
          { headerGroups.map( ( headerGroup ) => (
            <tr { ...headerGroup.getHeaderGroupProps() }>
              { headerGroup.headers.map( ( column ) => (
                <th
                  { ...column.getHeaderProps(
                    column.getSortByToggleProps()
                  ) }
                  style={ { padding: "8px" } }
                >
                  { column.render( "Header" ) }
                  <span>
                    { column.isSorted
                      ? column.isSortedDesc
                        ? " 🔽"
                        : " 🔼"
                      : "" }
                  </span>
                </th>
              ) ) }
            </tr>
          ) ) }
        </thead>
        <tbody { ...getTableBodyProps() }>
          { rows.map( ( row ) => {
            prepareRow( row );
            return (
              <tr
                { ...row.getRowProps() }
                style={ { borderBottom: "1px solid #ccc" } }
              >
                { row.cells.map( ( cell ) => (
                  <td
                    { ...cell.getCellProps() }
                    style={ { padding: "8px" } }
                  >
                    { cell.render( "Cell" ) }
                  </td>
                ) ) }
              </tr>
            );
          } ) }
        </tbody>
      </table>
    </div>
  );
};

export default App;